import { Navigate, Outlet, generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import { useAuth } from "@/providers";

export const AuthGuard = () => {
	const { isSignedIn } = useAuth();
	const CALLBACK_URL_KEY = "callbackUrl";
	const getCallbackUrl = (): string | null => new URLSearchParams(window.location.search).get(CALLBACK_URL_KEY);

	if (!isSignedIn) {
		return <Navigate to={generatePath(PATHS.AUTH.SIGN_IN, { search: getCallbackUrl() ?? "" })} replace />;
	}

	return <Outlet />;
};

AuthGuard.displayName = "AuthGuard";
